module.exports = __webpack_public_path__ + "static/feature-dual-weather-seals-stormproof-c266247ad4bc6e8289197f26fa3473e5.png";